jQuery(document).ready(function(){
	
  if( typeof Handlebars !== 'undefined' ){
  	
  	if( typeof giftaid_info !== 'undefined' && typeof jQuery('.giftaid-introduction')[0] !== 'undefined' && jQuery('script.giftaid-introduction-template')[0] !== 'undefined' ){
      	var giftaid_template = Handlebars.compile( jQuery('script.giftaid-introduction-template').html() );
		jQuery('.giftaid-introduction').html(  giftaid_template(giftaid_info) );  
    }
    
  }
  
  var countChecked = function() { 
    if( typeof jQuery('#giftaid')[0] !== 'undefined' && jQuery("#giftaid")[0].checked ) {
      jQuery("#taxstatement").show();
    } else {
      jQuery("#taxstatement").hide();
    }                              
  };
  countChecked();
  
  jQuery("#giftaid").on( "click", countChecked );       

  


var Shopify = Shopify || {};
  console.log( Shopify );
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "£{{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};  
  
    
  
  function calculate_freq_bought(){
  	var fb_main_container = jQuery('.fb-main-container');
    var fb_totals = {total: 0, item_quantity: 0};
    jQuery(fb_main_container).find('*[name="id"]').each(function(){
      if( typeof fb_totals.item_quantity === 'undefined' ){
      	fb_totals.total = 0;
      }
      if( typeof fb_totals.item_quantity === 'undefined' ){
      	fb_totals.item_quantity = 0;
      }
      
      var fb_prod = jQuery(this).closest('.fb-prod');
      
      var add_to_cart = jQuery(fb_prod).find('*[name="fb-add"]:checked');

      if( typeof jQuery(add_to_cart)[0] === 'undefined' ){
                
      	return;

      }
      
      var current_value = jQuery(this).val();
      
      var current_price = jQuery(this).find('option[value="'+current_value+'"]').data('price');
      
      fb_totals.total = fb_totals.total + current_price;
      fb_totals.item_quantity = fb_totals.item_quantity + 1;
    });
    fb_totals.total_format = Shopify.formatMoney( fb_totals.total );
    var fb_total_content = jQuery( fb_main_container ).find('script.fb-total-content').html();
    if( typeof Handlebars !== 'undefined' && typeof jQuery( fb_main_container ).find('script.fb-total-content')[0] !== 'undefined' ){
          var fbcontent_template = Handlebars.compile( fb_total_content );
          jQuery( fb_main_container ).find('.fb-total-container .total').html( fbcontent_template(fb_totals) );  
    }    
  } 
  
  function add_freq_to_cart(){
    
    var cart_data = [];
	var fb_main_container = jQuery('.fb-main-container');
    Shopify.queue = [];
    
    jQuery(fb_main_container).find('*[name="fb-add"]:checked').each(function(){
      var fb_prod = jQuery(this).closest('.fb-prod');
      
      
      var variant_info = jQuery(fb_prod).find('*[name="id"]');
      var current_value = jQuery(variant_info).val();
      
      Shopify.queue.push( {
      
      variantId: current_value,
      quantity: 1
    	
      } );
      
      
    });
    


    Shopify.moveAlong = function() {
      // If we still have requests in the queue, let's process the next one.
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        // pass the properties into addItem as well
        Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
      }
      // If the queue is empty, we will redirect to the cart page.
      else {
        document.location.href = '/cart';
      }
    };    
    
    Shopify.addItem = function(id, qty, properties, callback) {
      var params = {
        quantity: qty,
        id: id
      };
      if(properties != false){
        params.properties = properties;
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        success: function(){
          if(typeof callback === 'function'){
            callback();
          }
        },
        error: function(){
        	console.log( 'there was an error adding to cart' )
        }
      });
    }

    Shopify.moveAlong();
  
  }
  
  calculate_freq_bought();
  
  jQuery('body').on('change', '.fb-main-container *[name="id"], .fb-main-container *[name="fb-add"]', function(){
    calculate_freq_bought();
  });
  
  jQuery('body').on('click','.fb-add-to-cart',function(){
  	add_freq_to_cart();
  });
  
  function addUpsellToCart( $variant_info ){
      
    $.ajax({
       type: 'GET',
       url: '/cart.js',
       dataType: 'json',
       success: function( data ){
         var $all_ids = [];
         jQuery().each( data.items, function(item_index, item_obj ){
         	$all_ids.push( item_obj.id );
            $variant_info.qty = $variant_info.quantity + item_obj.quatity;
         });
         var in_cart = false;
         
         if( $all_ids.indexOf( $variant_info.id ) > -1 ){
         	in_cart = true;
         }
         
         var url, params = {};	
      
         if( in_cart ){
           url = '/cart/update.js';
           params.updates = {};
           params.updates[$variant_info.id] = $variant_info.quantity;
         }else{
           url = '/cart/add.js';
           params = {'items': [] };
           var param = {};
           param.id = $variant_info.id;
           param.quantity = $variant_info.quantity;
           params.items.push( param );
         }
         console.log( params );
         $.ajax({
           type: 'POST',
           url: url,
           dataType: 'json',
           data: params,
           success:function(data){
           		 window.location.href = '/cart';
           },
           error: function(){
           	console.log('error adding/updating cart');
           }
           
         });
         
       },
       error: function(){
       	console.log( 'error getting basket');
       }
    });
    	
   
  }  

  var fixedUpsellButtons = $( '[name="upsell-fixed-amount"]' ),
      upsellVariableAmount = $( '.upsell-variable-amount__input' );
  
  $(upsellVariableAmount).on('updateCart', function(){
          var qty = parseInt($(this).val().replace(/[^0-9.,]/,''), 10) || 0;
    	  var $variant_info = {};
          $variant_info.quantity = qty;
    	  $variant_info.id = $(this).data('variant-id');
          addUpsellToCart( $variant_info ); 	
  });
  
  $(fixedUpsellButtons).on('click', function(){
    $variant_info = {};
    $variant_info.id = $(this).val();
    $variant_info.quantity = 1;	
    addUpsellToCart( $variant_info ); 
  });
  
  upsellVariableAmount.on('keypress', function(e) {
    if (e.which === 13) {
      $(this).trigger( 'updateCart' );
      return false;
    }
  });  
  upsellVariableAmount.on('change, blur', function() {
	  $(this).trigger( 'updateCart' );
  });           
          
  
    var fixedAmountButtons = jQuery('[name="donation-fixed-amount"]'),
      donationVariableAmount = jQuery('.donation-variable-amount__input'),
      cartCountSelector = 'body .cart, #cart-count a:first, #gocart p a, #cart .checkout em, .item-count',
      cartFormButtons = jQuery('form[action="/cart"]').find('[name="update"], [name="checkout"], [name="goto_pp"], [name="goto_gc"]'),
      data = { updates: {} },
      qty = 0,
      variantId,
      isFixedAmount = true,
      updateDonation = function() {

        isFixedAmount = false;
        
        fixedAmountButtons.each(function() {
          variantId = jQuery(this).val();
          if (variantId) {
            if (jQuery(this).is(':checked')) {
              data['updates'][variantId] = 1;
              isFixedAmount = true;
            }
            else {
              data['updates'][variantId] = 0;
            }
          }
        });
        if( typeof dp_other_variant_id !== 'undefined' ){
        
          if (isFixedAmount) {
          donationVariableAmount.val('');
          data['updates'][dp_other_variant_id] = 0;
        	}
        else {
          qty = parseInt(donationVariableAmount.val().replace(/[^0-9.,]/,''), 10) || 0;
          data['updates'][dp_other_variant_id] = qty;
        }
        
        }

        jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js', 
          data: $('form[action="/cart"]').serialize(),
          dataType: 'json',
          success: function() {
            jQuery.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: data,
              dataType: 'json',
              success: function() {
                window.location.href = '/cart';
              },
              error: function (e) {
                console.log( e ); 
              }
            });
          },
          error: function( e ){
            console.log( e );
          }
        });
      }
           // Hide quantity box in cart form for variable donation amount.
           // Update cart item count too, so that a variable amount counts as 1 item.
         
         
           // Automatically add the donation when a button is clicked or variable amount changes.
           fixedAmountButtons.on('click', function() {
             if (jQuery(this).is('.active')) {
               jQuery(this).prop('checked', false);
               jQuery(this).removeClass('active');
               if (jQuery(this).val()) {
                 updateDonation();
               }
               else {
                 donationVariableAmount.val('');
                 donationVariableAmount.prop('disabled', true).addClass('donation-variable-amount__input--disabled');
                 updateDonation();
               }
             }
             else {
               fixedAmountButtons.removeClass('active');
               jQuery(this).addClass('active');
               if (jQuery(this).val()) {
                 updateDonation();
               }
               else {
                 donationVariableAmount.prop('disabled', false).removeClass('donation-variable-amount__input--disabled').get(0).focus();
               }
             }
           });
         
           // If Enter key is pressed while input box has focus, update donation.
           donationVariableAmount.on('keypress', function(e) {
             if (e.which === 13) {
               updateDonation();
               return false;
             }
           });
         
           // If Donation amount has changed, update donation.
           donationVariableAmount.on('change, blur', function() {
             cartFormButtons.prop('disabled', true);
             updateDonation();
           });           
        
  
});